import * as Yup from "yup";
const pickupValidationSchema = Yup.object({
  fullName: Yup.string()
    .matches(/^\w+( \w+)+$/, "Please enter a valid full name")
    .required("This field is required"),
  // contactNumber: Yup.number("Must be a number").required(
  //   "Please enter a contact number"
  // ),
  address: Yup.string().required("Please enter a pickup address"),
  // pickupDate: Yup.date()
  //   .min(
  //     new Date(Date.now()),
  //     "Pick up date must be greater than today's date!"
  //   )
  //   .required("Please enter a valid date"),
});

export { pickupValidationSchema };
